/**
 * Selfie Capture Error Codes.
 *
 * @enum {{SC001: string, SC002: string}}
 */
export const SELFIE_CAPTURE_ERROR_CODES = {
  SC001: 'SC001',
  SC002: 'SC002',
};

/**
 * Selfie Capture Error Messages.
 *
 * @enum {{SC001: string, SC002: string}}
 */
export const SELFIE_CAPTURE_ERRORS = {
  [SELFIE_CAPTURE_ERROR_CODES.SC001]:
    'Permission for camera use was not granted.',
  [SELFIE_CAPTURE_ERROR_CODES.SC002]: 'No video devices found',
};

/**
 * Web RTC Error Names.
 *
 * @enum {{NotAllowedError: string, NotFoundError: string, DevicesNotFoundError: string}}
 */
export const WEB_RTC_ERRORS = {
  NotAllowedError: 'NotAllowedError',
  NotFoundError: 'NotFoundError',
  DevicesNotFoundError: 'DevicesNotFoundError',
};
